import PropTypes from 'prop-types';
import style from './ActorAvatar.module.less';
import ReloadHelper from '../../utils/ReloadHelper';

const ActorAvatar = (props) => {
	const { isOnlineMobileVideocall, actorName, isOnline, onClick, linkVX, size, imgUrl, defaultBorder, isVip } = props;
	const wrapperClasses = [style['actor-avatar']];
	let text = 'LIVE';

	const styleClass = {};
	if (size) {
		styleClass.width = size + 'px';
		styleClass.height = size + 'px';
	}

	const beforeClick = (e) => {
		if (typeof onClick === 'function') {
			e.preventDefault();
			onClick(e);
		} else {
			ReloadHelper.reload(linkVX, e);
		}
	};

	if (defaultBorder || isOnlineMobileVideocall || isOnline || isVip) {
		wrapperClasses.push(style['actor-avatar--border']);
		if (size > 130) {
			wrapperClasses.push(style['actor-avatar--bw-5']);
		} else if (size > 100) {
			wrapperClasses.push(style['actor-avatar--bw-4']);
		} else if (size > 50) {
			wrapperClasses.push(style['actor-avatar--bw-3']);
		}
	}

	if (isVip) {
		wrapperClasses.push(style['actor-avatar--vip']);
	}

	if (isOnlineMobileVideocall) {
		wrapperClasses.push(style['actor-avatar--videocall']);
		text = 'ONLINE';
	} else if (isOnline) {
		wrapperClasses.push(style['actor-avatar--online']);
	}

	return (
		<a href={linkVX} className={wrapperClasses.join(' ')} onClick={beforeClick} style={styleClass}>
			<img src={imgUrl} alt={actorName} />
			<span>{text}</span>
		</a>
	);
};

ActorAvatar.propTypes = {
	isOnlineMobileVideocall: PropTypes.bool,
	defaultBorder: PropTypes.bool,
	actorName: PropTypes.string,
	isOnline: PropTypes.bool,
	onClick: PropTypes.func,
	linkVX: PropTypes.string,
	imgUrl: PropTypes.string,
	isVip: PropTypes.bool,
	size: PropTypes.number,
};

export default ActorAvatar;
